import type { FileRouteTypes } from '@/routeTree.gen'

/** Type-safe route paths from the generated route tree */
type RoutePath = FileRouteTypes['to']

/**
 * Role-based default routes
 * Returns the default landing page for each role
 */
export function getDefaultRouteForRole(roles: string[]): RoutePath {
  if (roles.includes('admin')) {
    return '/admin/users'
  }
  // Both agents and investors land on properties
  return '/properties'
}
